const getCatalogLocales = ({ locales }: { locales: CatalogLocales }): CatalogLocales => {
    return locales;
};

export default { getCatalogLocales };
